import React, { Component } from "react";
import tags from "../../graphql/queries/tags";
import { Select, Skeleton } from "antd";
import { Query } from "react-apollo";
class TagSelect extends Component {
  render() {
    return (
      <div>
        <Query query={tags}>
          {({ loading, data, error }) => {
            if (loading) return <Skeleton />;
            if (error) return <div>{error.toString()}</div>;
            return (
              <Select
                placeholder="Select..."
                mode="multiple"
                optionFilterProp="children"
                value={this.props.value ? this.props.value : []}
                onChange={(value) => {
                  this.setState({ value }, () => this.props.onChange(value));
                }}
              >
                {data?.productTags?.nodes.map((el) => (
                  <Select.Option key={el.id} value={el.id}>
                    {el.title}
                  </Select.Option>
                ))}
              </Select>
            );
          }}
        </Query>
      </div>
    );
  }
}

export default TagSelect;
